<template>
    <div class="A4-land">
        <div class="row">
            <div class="col-sm-12">
                <div class="print-header">
                    <h4 class="text-center font-m">{{$t('purchase_operation_detail')}}</h4>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <table class="table table-bordered table-sm table-striped no-bor">
                    <thead>
                        <tr>
                            <th style="width: 50px;" class="text-center">{{$t('no')}}</th>
                            <th>{{$t('invoice_no')}}</th>
                            <th>{{$t('date')}}</th>
                            <th>{{$t('item_code')}}</th>
                            <th>{{$t('item_name')}}</th>
                            <th class="text-right">{{$t('qty')}}</th>
                            <th class="text-right">{{$t('cost')}}</th>
                            <th class="text-right">{{$t('total_sale_amount')}}</th>
                            <th class="text-right">{{$t('discount')}}</th>
                            <th class="text-right">{{$t('total_amount')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(ret, index) in records" :key="index">
                            <td class="text-center">{{index+1}}</td>
                            <td>{{ret.InvoiceNum}}</td>
                            <td>{{$format(ret.InvoiceNum, 'DD/MM/YYYY')}}</td>
                            <td>{{ret.ItemCode}}</td>
                            <td>{{ret.ItemName}}</td>
                            <td class="text-right">{{$number(ret.Quantity)}}</td>
                            <td class="text-right">{{$money(ret.Price)}}</td>
                            <td class="text-right">{{$money(ret.Quantity * ret.Price)}}</td>
                            <td class="text-right">{{$money(ret.Discount)}}</td>
                            <td class="text-right">{{$money(ret.SubTotal)}}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <th colspan="7" class="text-right">{{$t('total')}}</th>
                            <th class="text-right">{{$money(summary.GrandTotal)}}</th>
                            <th class="text-right">{{$money(summary.Discount)}}</th>
                            <th class="text-right">{{$money(summary.SubTotal)}}</th>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data: function(){
            return {
                query:{
                    Year: new Date().getFullYear(),
                    Month: new Date().getMonth() + 1,
                },
                records:[],
                summary: {
                    GrandTotal: 0,
                    Discount: 0,
                    SubTotal: 0,
                    TotalCost: 0,
                    GrossProfit: 0
                }
            }
        },
        created: function(){
            let linkQuery = this.$route.query;
            if(linkQuery.year != undefined && linkQuery.year != null && linkQuery.year != ''){
                this.query.Year = linkQuery.year;
            }
            if(linkQuery.month != undefined && linkQuery.month != null && linkQuery.month != ''){
                this.query.Month = linkQuery.month;
            }
            this.toList();
        },
        methods: {
            toList(){
                var loading = this.$loading.show();
                this.$api().post('report/purchase/detail', this.query).then((res) => {
                    if(this.$isValid(res)){
                        this.records = res.data.Json.Lines;
                        this.calculate();
                    }
                }).finally(function() { loading.hide(); });
            },
            calculate(){
                let grand_total = 0;
                let discount = 0;
                let totalAmount = 0;
                let balance = 0;
                this.records.map(el => {
                    grand_total += el.Quantity * el.Price;
                    discount += el.Discount;
                    totalAmount += el.SubTotal;
                });
                this.summary.GrandTotal = grand_total;
                this.summary.Discount = discount;
                this.summary.SubTotal = totalAmount;
                this.summary.Balance = balance;
            }
        }
    }
</script>